import { render, staticRenderFns } from "./EditSnackbar.vue?vue&type=template&id=4b70a373&scoped=true&"
import script from "./EditSnackbar.vue?vue&type=script&lang=js&"
export * from "./EditSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70a373",
  null
  
)

export default component.exports